<template>
    <v-form-item
        :required="true"
        :rules="rules"
        @error="error"
        name="menuName"
        label="按钮名称"
    >
        <v-input
            ref="menuName"
            v-model="name"
            :limit="limit"
            :reg="regexp"
            name="menuName"
            placeholder="请输入"
            error-placement="bottom"
            class="menu-name-input"
        />
    </v-form-item>
</template>

<script>
import { VALID_REG } from '../../constants';

export default {
    props: {
        choseName: {
            type: String,
            default: '',
        },
        limit: {
            type: Number,
            default: 20,
        },
        defaultName: {
            type: String,
            default: '',
        },
        index: {
            type: Number | String,
            default: '',
        },
        menu:{
            type: Object,
            default: () => ({ list: [] }),
        },
    },
    data() {
        return {
            name: '',
            regexp: new RegExp(`^\\S{0,${this.limit}}$`), // 禁止输入空格
            errorTip: '',

            rules: [
                { required: true, message: '请填写按钮名称', trigger: 'blur,submit' },
                { validate: VALID_REG.menuName, message: '每个按钮2-8个字', trigger: 'blur,submit' },
                {
                    validate: (val, rule) => {
                        // 第一个不校验重复性
                        if (this.index === 0) {
                            return true;
                        }

                        for (let i = 0; i < this.menu.list.length; i++) { 
                            if (i !== this.index && this.menu.list[i].name === val) {
                                return false;
                            }
                        }

                        return true;
                    },
                    message: '按钮名称重复',
                    trigger: 'blur,submit'
                },
            ],
        };
    },
    watch: {
        choseName() {
            if (this.choseName !== undefined) {
                this.name = this.choseName;
            }
        },
        name() {
            this.$emit('changeName', this.name, this.index);
        },
        repeatError(val) {
            if (this.errorMsg === '') {
                this.errorTip = val;
            }
        },
    },
    mounted() {
        this.name = this.choseName !== '' && !!this.choseName ? this.choseName : this.defaultName;
    },
    methods: {
        focus() {
            this.$refs.menuName.focus();
        },
        error(msg) {
            this.$emit('error', msg);
        },
    },
};
</script>

<style lang="less" scoped>
    .menu-name-input{
        width: 100%;
    }
</style>
